import { FunctionComponent } from "react";
import { GameMode } from "./Types";

interface Props {
  gameMode: GameMode;
  onClose: () => void;
}

const BACKGAMMON_RULES = [
  { title: "Цель игры", text: "Первым снять все свои 15 шашек с доски (вынести их домой)." },
  { title: "Начало", text: "Каждый игрок бросает по одному кубику. У кого больше — ходит первым этими же числами." },
  { title: "Движение", text: "Шашки двигаются только в одном направлении. Можно ходить двумя разными шашками или одной — на сумму двух кубиков." },
  { title: "Занятые точки", text: "Нельзя встать на точку, занятую двумя и более шашками соперника. Одиночная шашка соперника — блот, её можно побить." },
  { title: "Бар", text: "Сбитая шашка уходит на бар. Пока есть шашки на баре, нужно вводить их с противоположной стороны доски — другие ходы запрещены." },
  { title: "Максимум кубиков", text: "Нужно использовать оба кубика по возможности. Если можно использовать только один — используй больший." },
  { title: "Выброс", text: "Когда все шашки в домашней четверти (очки 1–6) — можно начинать выброс. Кубик ≥ дистанции шашки: можно снять. Точный или меньший: двигать вперёд." },
  { title: "Дублирование (куб)", text: "До броска можно предложить удвоение ставки. Соперник принимает или сдаётся. Владелец куба может удвоить снова." },
  { title: "Гаммон / Бэкгаммон", text: "Если проигравший не снял ни одной шашки — гаммон (×2). Если ещё и шашка на баре или в домашней четверти победителя — бэкгаммон (×3)." },
];

const LONG_NARDY_RULES = [
  { title: "Цель игры", text: "Первым вывести все 15 шашек за доску (вынести их домой). Нет ударов и бара — шашки соперника нельзя бить." },
  { title: "Начальная расстановка", text: "Все 15 шашек каждого игрока стоят на своей голове. Белые — точка 24 (правый верхний угол), чёрные — точка 12." },
  { title: "Движение", text: "Оба игрока движутся против часовой стрелки. Нельзя вставать на точку, занятую хотя бы одной шашкой соперника." },
  { title: "Правило головы", text: "За один ход с головы можно снять не более одной шашки. Исключение: первый ход игрока, если выпали дубли 3-3, 4-4 или 6-6." },
  { title: "Запрет блокировки", text: "Нельзя выстраивать 6 своих шашек подряд, если все шашки соперника уже позади этого заграждения." },
  { title: "Максимум кубиков", text: "Обязательно использовать максимально возможное количество костей. При выборе одной из двух — выбирай большую." },
  { title: "Выброс", text: "Когда все шашки прошли полный круг и вошли в домашнюю четверть (последние 6 точек) — начинается выброс." },
  { title: "Дубли", text: "При выпадении дублей делается 4 хода (например, 5-5 = четыре хода по 5). Дубль 6-6 в первом ходе позволяет снять 2 шашки с головы." },
  { title: "Победа", text: "Если оба вынесли все шашки — ничья. Если ты последний — проигрыш. Если соперник не вынес ни одной — марс (двойная победа)." },
];

const RulesModal: FunctionComponent<Props> = ({ gameMode, onClose }) => {
  const isLongNardy = gameMode === GameMode.LongNardy;
  const rules = isLongNardy ? LONG_NARDY_RULES : BACKGAMMON_RULES;
  const title = isLongNardy ? "Правила длинных нард" : "Правила нард (короткие)";

  return (
    <div className="Rules-overlay" onClick={onClose}>
      <div className="Rules-modal" onClick={e => e.stopPropagation()}>
        <div className="Rules-header">
          <span className="Rules-title">{title}</span>
          <button className="Rules-close" onClick={onClose}>✕</button>
        </div>
        <div className="Rules-body">
          {rules.map((r, i) => (
            <div key={i} className="Rules-item">
              <div className="Rules-item-title">{i + 1}. {r.title}</div>
              <div className="Rules-item-text">{r.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RulesModal;
